export default "__VITE_ASSET__b24dbf0f__"